import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

msalInstance.initialize().then(() => {
  // Handle the redirect promise to process the response from Microsoft
  msalInstance.handleRedirectPromise().then((tokenResponse) => {
    // Check if we have an active account or if one was returned
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Continue with rendering the app
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  }).catch((error) => {
    console.error("Authentication error:", error);
    // Display a friendly error message on the screen
    root.render(
      <div style={{ padding: '40px', fontFamily: 'sans-serif', color: '#721c24', backgroundColor: '#f8d7da' }}>
        <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Error de Autenticación</h1>
        <p>Hubo un problema al intentar iniciar sesión con Microsoft.</p>
        <pre style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '5px', overflow: 'auto', marginTop: '10px' }}>
          {error.toString()}
        </pre>
        <p style={{ marginTop: '20px' }}>
          <strong>Posible solución:</strong> Verifica que en Azure Portal la plataforma esté configurada como
          <em> "Single-Page Application" (SPA)</em> y no como <em>"Web"</em>.
        </p>
      </div>
    );
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
